import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  addPattern,
  deletePattern,
  getPatternDefForPage,
} from '@wix/wix-data-client-common'
import type {
  DynamicPageRouterData,
  EditorSDK,
  PatternDefinition,
} from '@wix/wix-data-client-common-standalone'
import { MAIN_SLUG_FIELD_KEY } from '../../slug/constants'
import { generateUniquePageLinkId } from '../../slug/generatePageLinkId'

const createNewPatternDefinition = (
  oldPatternDef: PatternDefinition,
  newCollectionId: string,
  pageLinkId?: string,
) => {
  const { collection, sort, filter, ...oldConfigBase } = oldPatternDef.config
  return {
    ...oldPatternDef,
    config: {
      ...oldConfigBase,
      collection: newCollectionId,
      ...(pageLinkId ? { pageLinkId } : {}),
    },
  }
}

export const prepareRouteData = async ({
  oldRouter,
  pageRef,
  newCollectionId,
  editorSdkProxy,
}: {
  oldRouter: DynamicPageRouterData
  pageRef: PageRef
  newCollectionId: string
  editorSdkProxy: EditorSDK
}) => {
  const patternCount = Object.keys(oldRouter.config.patterns).length
  if (patternCount > 1) {
    throw new Error('Not implemented for routers with multiple patterns')
  }

  const { pattern: oldPattern, def: oldPatternDef } = getPatternDefForPage(
    oldRouter.config,
    oldRouter.pages,
    pageRef,
  )

  const newPattern = `/{${MAIN_SLUG_FIELD_KEY}}`
  const pageLinkId = await generateUniquePageLinkId({ editorSdkProxy })

  const newPatternDef = createNewPatternDefinition(
    oldPatternDef,
    newCollectionId,
    pageLinkId,
  )

  const configWithoutOldPattern = deletePattern(oldRouter.config, oldPattern)

  const updatedRouterConfig = addPattern(
    configWithoutOldPattern,
    newPattern,
    newPatternDef,
  )

  return {
    updatedRouterConfig,
  }
}
